
/**
 * The one same-origin authenticated POST. Auth is fully proxied through `/auth/*` (and the
 * server-gated `/internal/*`), so every mutating call is `credentials: 'include'` and carries the
 * `x-cheddule-request` marker the Yoga CSRF plugin checks. Returns the raw {@link Response} so each
 * caller keeps its own status/error handling. See docs/auth-and-session.md.
 */
export function authPost(
  path: string,
  marker: string,
  body?: unknown,
  extraHeaders?: Record<string, string>,
): Promise<Response> {
  const init: RequestInit = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...extraHeaders,
      'x-cheddule-request': marker,
    },
  };
  if (body !== undefined) {
    init.body = JSON.stringify(body);
  }
  return fetch(path, init);
}
